import { render, staticRenderFns } from "./DefaultMap.vue?vue&type=template&id=4907a6fa"
import script from "./DefaultMap.vue?vue&type=script&lang=js"
export * from "./DefaultMap.vue?vue&type=script&lang=js"
import style0 from "./DefaultMap.vue?vue&type=style&index=0&id=4907a6fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports